import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";

import useEbayAspects from "../../data/useEbayAspects";
import usePartDefaultCategoryAssignees from "../../data/usePartDefaultCategoryAssignees";
import { IPartCategory } from "../../models/Part";
import { RadioGroupInput } from "../shared/Inputs/RadioGroupInput";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { IPartCategoryDefault } from './../../models/Part';
import { TextInput } from "../shared/Inputs/TextInput";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import usePartAspectsMutations from "../../data/usePartAspectsMutations";
import { CheckboxInput } from "../shared/Inputs/CheckboxInput";
import SingleCategoryCustomAspect from "./SingleCategoryCustomAspect";


const assigneeOptions = [
  { name: "None", value: 0 },
  { name: "Imager", value: 1 },
  { name: "Dismantler", value: 2 }
];

interface IFormValues {
  assignee: number;
}

const IndividualAspect = ({ aspect, category }: { aspect: any, category: IPartCategory | undefined }) => {
  const { addAssignee, removeAssignee } = usePartDefaultCategoryAssignees();
  const { saveHandlers } = useDefaultCRUDHandlers("Default Assignee");
  const { register, getValues, setValue, watch, handleSubmit, reset, control } = useForm<IFormValues>({
    defaultValues: {
      assignee: category?.partCategoryDefaults[0]?.aspectAssignees?.find((a) => a.aspectName === aspect.localizedAspectName)?.assignee || 0
    }
  });

  const handleSetValue = (registerName: string, value: any) => {

    //Do an update mutation here
    //create or remove the default assignee for this aspect
    const body = {
      defaultCategoryId: category?.partCategoryDefaults[0]?.id,
      aspectName: aspect.localizedAspectName,
      assignee: value,
      imageUrl: null,
      isImageRequired: false
    };

    addAssignee.mutate(body, {
      onSuccess: () => {
        setValue("assignee", value);
        saveHandlers.onSuccess();
      },
      onError: () => {
        saveHandlers.onError();
      }
    });


    // setValue("assignee", value);
  };

  return (
    <div className="grid grid-cols-3 border-0 border-b pb-4">
      <div className="flex items-center">
        <label className="font-medium text-gray-500">{aspect.localizedAspectName}</label>
      </div>
      <div>
        <RadioGroupInput options={assigneeOptions} register={register} registerName={"assignee"} setValue={handleSetValue} watch={watch} />
      </div>

      {aspect.aspectValues && (
        <div>
          <span className="text-sm font-medium text-gray-500">
            Options{aspect.aspectConstraint?.itemToAspectCardinality === "MULTI" ? " (multi)" : ""}:{" "}
          </span>
          <select className="py-1 border border-gray-400 rounded text-sm text-gray-700">
            {aspect.aspectValues?.slice(0, 100).map((option: any, i: number) => {
              return (
                <option key={`${option.localizedValue}-${i}`}>
                  {option.localizedValue}
                </option>
              )
            })}
          </select>
        </div>
      )}
    </div>
  )
};

interface newAspectFormValues {
  id: string | null;
  partCategoryDefaultsId: string | null;
  name: string;
  options: string | null;
  isRequired: boolean;
}

export default function CategoryAspectsDefaults({ category }: { category: IPartCategory | undefined }) {
  const [ebayCategoryId, setEbayCategoryId] = useState<string | null | undefined>(category?.partCategoryDefaults[0]?.ebayCategoryId);
  const [categoryDefaults, setCategoryDefaults] = useState<IPartCategoryDefault | undefined>(category?.partCategoryDefaults[0]);
  const { saveHandlers } = useDefaultCRUDHandlers("Category Default Aspect");
  const { aspects: ebayAspects } = useEbayAspects(ebayCategoryId!);
  const { createUpdateCategoryDefaults } = usePartAspectsMutations();

  const { register, reset, handleSubmit } = useForm<newAspectFormValues>({
    defaultValues: {
      id: null,
      partCategoryDefaultsId: category?.partCategoryDefaults[0]?.id!,
      name: "",
      options: null,
      isRequired: false
    }
  });

  const onSubmit = (data: newAspectFormValues) => {
    const newAspect = {
      ...data,
    };

    createUpdateCategoryDefaults.mutate(newAspect, {
      ...saveHandlers,
      onSuccess: () => {
        reset();
      }
    });
  }

  useEffect(() => {
    if (category?.partCategoryDefaults && category.partCategoryDefaults.length > 0) {
      setCategoryDefaults(category.partCategoryDefaults[0]);
      setEbayCategoryId(category.partCategoryDefaults[0]?.ebayCategoryId);
    }
  }, [category]);


  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-lg mb-4">Category Default Custom Aspects</h1>
        <div className="pt-4 flex flex-col gap-4 sm:gap-y-6">
          {categoryDefaults?.categoryCustomAspects?.map((aspect, i) => (
            <SingleCategoryCustomAspect key={i} aspect={aspect} />
          ))}
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="border border-gray-200 rounded p-3">
          <h2 className="text-sm font-semibold mb-2">Add Category Custom Aspect:</h2>
          <div className="grid grid-cols-2 gap-3">
            <TextInput label={"Category Aspect Name (Max: 40)"} register={register} registerName={"name"} maxLength={40} />
          </div>
          <div className="mt-2">
            <ButtonInput
              label={"Add Category Aspect"}
              isSubmit
              onClick={undefined}
              classes={undefined}
              isLoading={createUpdateCategoryDefaults.isLoading}
            />
          </div>
        </form>
      </div>

      <div>
        <h1 className="text-lg mb-4">eBay Item Aspect Defaults</h1>
        <div className="border-t border-gray-200 pt-4 flex flex-col gap-4 sm:gap-y-6">
          {ebayAspects?.data?.map((aspect, i) => (
            <IndividualAspect key={i} aspect={aspect} category={category} />
          ))}
        </div>
      </div>
    </div>
  );
};